import { useQuery as useGetMerchandisedCollections } from "@faire/web-api/api/v2/merchandised-collections/vanityUrl/get-hooks";
import { useRouteMatch } from "@faire/web-api/pathMatchesRoute";

export const useMerchanisedCollection = () => {
  const {
    params: { mcVanityUrl },
  } = useRouteMatch<"/merchandised-collection/mcVanityUrl">();

  const {
    data: merchandisedCollectionsData,
    isLoading,
    isError,
    error,
  } = useGetMerchandisedCollections(mcVanityUrl ?? "");

  const merchandisedCollection = merchandisedCollectionsData?.collection;

  const breadcrumbOptions = merchandisedCollection?.name
    ? [
        {
          label: merchandisedCollection.name,
        },
      ]
    : [];

  return {
    merchandisedCollection,
    isLoading,
    isError,
    error,
    breadcrumbOptions,
    requestId: merchandisedCollectionsData?.request_id,
  };
};
